import { Skeleton } from 'primereact/skeleton';
import RotuloSeplag from '../../components/RotuloSeplag';

const ObrigacaoLoader = () => {

  return (
    <div className="p-grid p-col-12">
      {/*       
      <div className="p-col-12 p-md-12 p-lg-6 p-grid" style={{ margin: 0 }}>

        <div className="p-col-2 p-md-1 p-lg-1">
          <Skeleton
            width="20px"
            height="20px"
            style={{ border: '2px solid #ced4da' }}
          />
        </div>
        <RotuloSeplag nome="Quitadas" cols="10 3 " />

        <div className="p-col-2 p-md-1 p-lg-1">
          <Skeleton width="20px" height="20px" />
        </div>
        <RotuloSeplag nome="Em Compensação" cols="10 3 " />

        <div className="p-col-2 p-md-1 p-lg-1">
          <Skeleton width="20px" height="20px" />
        </div>
        <RotuloSeplag nome="Autenticadas" cols="10 3 " />
      </div>

      <div className="p-col-12 p-md-12 p-lg-6 p-grid" style={{ margin: 0 }}>

        <div className="p-col-2 p-md-1 p-lg-1">
          <Skeleton width="20px" height="20px" />
        </div>
        <RotuloSeplag nome="Emitidas" cols="10 3 " />

        <div className="p-col-2 p-md-1 p-lg-1">
          <Skeleton width="20px" height="20px" />
        </div>
        <RotuloSeplag nome="Não Emitidas (Só Obrigação)" cols="10 3 " />
      </div>
      */}
      <div className='p-col-12' />

      <RotuloSeplag nome="Beneficiário" cols="12 6 3">
        <Skeleton width="100%" height="35px" />
      </RotuloSeplag>

      <RotuloSeplag nome="CPF" cols="12 6 3">
        <Skeleton width="100%" height="35px" />
      </RotuloSeplag>

      <RotuloSeplag nome="Matrícula" cols="12 6 3">
        <Skeleton width="100%" height="35px" />
      </RotuloSeplag>

      <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6 3">
        <Skeleton width="100%" height="35px" />
      </RotuloSeplag>

      <div className="p-col-12 p-md-2" style={{ marginTop: '25px' }}>
        <Skeleton width="6.8rem" height="2.5rem" className="p-col" ></Skeleton>
      </div>
    </div>
  )
}


export default ObrigacaoLoader;